/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.templates.create.schedules.create.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.permissions',
  'acme.common.service.templates',
  'acme.common.service.helpers',
  'acme.common.service.validate',
  'acme.common.service.calendar',
  'acme.common.service.themesHelper',
  'acme.common.factory.wizard',
  'acme.view.application.templates.create.schedules.create.removeModal.controllers'
])

.controller('TemplatesCreateSchedulesCreateController', [
  '$scope',
  '$state',
  '$uibModal',
  '$timeout',
  '$filter',
  'ApiService',
  'EventTemplateData',
  'TemplatesService',
  'HelpersService',
  'CalendarService',
  'ValidateService',
  'PermissionsService',
  'ThemesHelperService',
  function($scope,
           $state,
           $uibModal,
           $timeout,
           $filter,
           ApiService,
           EventTemplateData,
           TemplatesService,
           HelpersService,
           CalendarService,
           ValidateService,
           PermissionsService,
           ThemesHelperService) {

    $scope.templatesCreateSchedulesCreate = {

      model: {},
      template: {},

      isSaving: false,
      isUpdate: false,

      mode: 'create',
      cap: HelpersService.cap,

      emailSetting: 'always',
      company: ThemesHelperService.getCompany(),

      type: 'standard',

      init: function() {
        var title = '';

        if (EventTemplateData.data && EventTemplateData.data.success) {
          this.success.init(EventTemplateData);
        }else{
          this.error.init(EventTemplateData);
        }

        if($state.params) {
          if ($state.params.scheduleId) {
            this.mode = 'edit';
          }

          if (
            $state.params.type && $state.params.type === 'private' ||
            this.model.type === 'private'
          ) {
            for (var i in this.model.salesChannels) {
              if (this.model.salesChannels[i].channel === 'online') {
                this.model.salesChannels[i].enabled = false;
                break;
              }
            }
            title = this.cap(this.mode) + ' Private Event Schedule';
          } else {
            title = this.cap(this.mode) + ' Event Template Schedule';
          }
        }

        ValidateService.clearFieldTests();

        $scope.$emit('Application::contentTitleChange', {
          title: title,
          buttonLeft: {
            label: 'Close',
            action: function() {
              $scope.templatesCreateSchedulesCreate.cancel();
            }
          },
          buttonRight: {
            label: (this.isMode('edit')) ? 'Save' : 'Save & Continue',
            action: function() {
              var self = $scope.templatesCreateSchedulesCreate;
              if (self.isMode('create')) {
                self.save('pricing', true);
              }else{
                self.save(false, true);
              }
            }
          }
        });

        this.getNotificationPreference();

        $scope.$on('TemplatesCreateSchedulesCreateController::Error', this.onError);

        console.log('TemplatesCreateSchedulesCreateController::init');
      },

      getNotificationPreference: function() {
        if (this.company.hasOwnProperty('notificationPreference')) {
          this.emailSetting = this.company.notificationPreference;
        }
      },

      isMode: function(mode) {
        return (this.mode === mode);
      },

      isReviewState: function(state) {
        return (TemplatesService.getReviewState() === state);
      },

      isPrivateSchedule: function() {
        return (this.model.type === 'private');
      },

      isState: function(state) {
        var r;

        if ($state.params && $state.params.scheduleId) {
          r = ($state.current.name.indexOf('application.templates.edit.schedules.edit.'+state) === 0);
        }else {
          r = ($state.current.name.indexOf('application.templates.edit.schedules.create.'+state) === 0);
        }
        return r;
      },

      getState: function(name) {
        var r;

        if ($state.params && $state.params.scheduleId) {
          r = 'application.templates.edit.schedules.edit.' + name + '({ scheduleId: "' + $state.params.scheduleId + '" })';
        }else{
          r = 'application.templates.edit.schedules.create.' + name;
        }

        return r;
      },

      cancel: function() {
        TemplatesService.removeNewSchedule();
        $state.go('application.templates.edit.schedules');
      },

      remove: function() {
        var self = $scope.templatesCreateSchedulesCreate;

        self.showModal = $uibModal.open({
          templateUrl: 'views/application/views/templates/create/schedules/modals/removeSchedule.tpl.html',
          size: 'md',
          controller: 'TemplatesCreateSchedulesRemoveModalController',
          resolve: {
            currentSchedule: function() {
              return self.model;
            },
            SoldQuantity: function() {
              return self.model.soldQuantity;
            },
            emailSetting: function() {
              return self.emailSetting;
            }
          }
        });

        self.showModal.result.then(function () {
          ApiService.program.schedules.remove({
            eventTemplateId: self.template.id,
            id: self.model.id
          }).then(self.success.remove, self.error.remove);
        }, function () {
        });
      },

      save: function(stateName, update) {
        var self = $scope.templatesCreateSchedulesCreate;

        this.isSaving = true;
        this.isUpdate = (update);

        $scope.$broadcast('TemplatesCreateSchedulesCreateController::Save');

        ValidateService.runFieldTests();

        // next tick
        $timeout(function() {
          if (ValidateService.errors.length === 0) {
            if ($state.params.scheduleId) {
              self.update(stateName);
            } else {
              self.create(stateName);
            }
          }else{
            self.isSaving = false;
          }
        }, 0);
      },

      prepare: function(schedule) {
        schedule.eventTemplateId = $state.params.id;
        schedule.name = this.model.name;

        return schedule;
      },

      update: function(stateName) {
        ApiService.program.schedules.update(this.prepare(TemplatesService.getScheduleById($state.params.scheduleId).schedule)).then(function(response) {
          var self = $scope.templatesCreateSchedulesCreate;

          self.isSaving = false;

          if (stateName) {
            TemplatesService.setSchedule(response.data.payload);
            $state.go('application.templates.edit.schedules.edit.' + stateName, { scheduleId: response.data.payload.id });
          }else {
            self.success.update(response);
          }
          self.isUpdate = false;

        }, this.error.update);

      },

      create: function(stateName) {
        ApiService.program.schedules.create(this.prepare(TemplatesService.getNewSchedule().schedule)).then(function(response) {
          var self = $scope.templatesCreateSchedulesCreate;

          self.isSaving = false;

          if (stateName) {
            $state.go('application.templates.edit.schedules.edit.' + stateName, { scheduleId: response.data.payload.id });
          }else {
            self.success.create(response);
          }
          self.isUpdate = false;

        }, this.error.create);
      },

      setUpdateTimes: function(template) {
        if (template) {
          if (template.lastUpdated) {
            this.lastUpdated = $filter('date')(CalendarService.parseDate(template.lastUpdated), HelpersService.dateFormats.shortDateTime);
          }
          if (template.lastPublished) {
            this.lastPublished = $filter('date')(CalendarService.parseDate(template.lastPublished), HelpersService.dateFormats.shortDateTime);
          }
        }
      },

      showScheduleAlert: function() {
        var self = $scope.templatesCreateSchedulesCreate;
        return self.isReviewState('published') && !self.isPrivateSchedule() && ($state.params.scheduleId !== undefined);
      },

      success: {
        init: function(response) {
          var self = $scope.templatesCreateSchedulesCreate;

          TemplatesService.setModel(response.data.payload);
          self.template = TemplatesService.getModel();
          self.setUpdateTimes(self.template);

          if ($state.params.scheduleId) {
            self.model = TemplatesService.getScheduleById($state.params.scheduleId).schedule;
          }else {
            self.model = TemplatesService.getNewSchedule().schedule;

            if (
              $state.params &&
              $state.params.type &&
              $state.params.type === 'private'
            ) {
              self.model.type = $state.params.type;
              for (var i in self.model.salesChannels) {
                if (self.model.salesChannels[i].channel === 'online') {
                  self.model.salesChannels[i].enabled = false;
                  break;
                }
              }
            }
          }
        },
        create: function(response) {
          var self = $scope.templatesCreateSchedulesCreate;

          self.isSaving = false;

          if (!self.isUpdate) {
            $state.go('application.templates.edit.schedules');
          }
        },
        update: function(response) {
          var self = $scope.templatesCreateSchedulesCreate;

          self.isSaving = false;

          if (!self.isUpdate) {
            $state.go('application.templates.edit.schedules');
          } else {
            TemplatesService.setSchedule(response.data.payload);
          }
        },
        remove: function(response) {
          $state.go('application.templates.edit.schedules');
        }
      },

      error: {
        init: function(response) {},
        create: function(response) {
          var self = $scope.templatesCreateSchedulesCreate;

          self.isSaving = false;
          self.error.generic(response);
        },
        update: function(response) {
          var self = $scope.templatesCreateSchedulesCreate;

          self.isSaving = false;
          self.error.generic(response);
        },
        remove: function(response) {
          $scope.templatesCreateSchedulesCreate.error.generic(response);
        },
        generic: function(response) {
          $scope.$emit('TemplatesCreateSchedulesCreateController::Error', { message: response.data.error });
        }
      },

      onError: function(e, data) {
        var self = $scope.templatesCreateSchedulesCreate;

        if (data.message) {
          self.showModal = $uibModal.open({
            templateUrl: 'views/application/views/reports/create/modals/showMessage.tpl.html',
            size: 'md',
            controller: 'ReportsCreateShowMessageModalController',
            resolve: {
              currentTitle: function () {
                return 'An error has occurred';
              },
              currentMessage: function () {
                return data.message;
              },
              safe: function() {
                return true;
              }
            }
          });
          // Invoked when modal completes with close(params)
          self.showModal.result.then(function () {
            if (typeof(data.callback) === 'function') {
              data.callback();
            }
            if (data.state) {
              if (data.stateParams) {
                $state.go(data.state, data.stateParams);
              }else{
                $state.go(data.state);
              }
            }
          }, function () {
            // Do nothing
          });
        }
      }

    };

    $scope.templatesCreateSchedulesCreate.init();

}]);